import { fork, all, takeLatest } from 'redux-saga/effects';
import {
    GET_CONSIGNMENTRETURN_DETAILS,
    GET_USAGE_DETAILS,
    GET_INVENTORY_DATA,
    SAVE_CONSIGNMENTRETURN_ORDER,
    VALIDATE_PRODUCT_DETAILS,
    VALIDATE_ACCOUNT,
} from '../actions';
import {
    getConsignmentReturnDetails,
    validateProductDetailsInReturnSaga,
} from './getConsignmentDetailsSaga';
import getUsageDetails from './usageDetails';
import getInventoryDetails from './getInventoryDetailsSaga';
import postConsignmentOrderReturn from './consignmentReturnOrderSaga';
import validateAccountSaga from 'src/pages/equity/redux/saga/validateAccountSaga';

// function* watchGetProductsTemplatesFilterSaga() {
//     yield takeEvery(GET_PRODUCTSTEMPLATESFILTER, productsTemplatesFilterSaga);
// }

function* watchGetConsignmentReturnDetailsSaga() {
    yield takeLatest(
        GET_CONSIGNMENTRETURN_DETAILS,
        getConsignmentReturnDetails
    );
}

function* watchGetUsageDetailsSaga() {
    yield takeLatest(GET_USAGE_DETAILS, getUsageDetails);
}

function* watchGetInventoryDetailsSaga() {
    yield takeLatest(GET_INVENTORY_DATA, getInventoryDetails);
}

function* watchUpdateConsignmentSaga() {
    yield takeLatest(SAVE_CONSIGNMENTRETURN_ORDER, postConsignmentOrderReturn);
}

function* watchValidateProductDetailsInReturnSaga() {
    yield takeLatest(
        VALIDATE_PRODUCT_DETAILS,
        validateProductDetailsInReturnSaga
    );
}

function* watchValidateAccountSaga() {
    yield takeLatest(VALIDATE_ACCOUNT, validateAccountSaga);
}

export default function* consignmentReturnDetailsRootSaga() {
    yield all([
        // fork(watchGetPricesForItemsSaga),
        fork(watchGetConsignmentReturnDetailsSaga),
        fork(watchUpdateConsignmentSaga),
        fork(watchGetUsageDetailsSaga),
        fork(watchGetInventoryDetailsSaga),
        fork(watchValidateProductDetailsInReturnSaga),
        fork(watchValidateAccountSaga),
    ]);
}
